// Which platforms a client can actually work on.
//
// Settings has two switches and they mean the same thing at different scopes: Deactivate on
// the Platforms tab turns a platform off everywhere, unchecking it on the Clients tab turns
// it off for one client. A platform is usable only if BOTH are on, so every screen that
// offers new work asks this rather than checking one half and disagreeing with the other.
//
// This governs NEW work only. Campaigns already built on a platform that has since been
// disabled stay visible and render their saved rows — they go read-only instead. The backend
// marks them via disabled_platform_ids on the campaign payload; do not re-derive that here,
// because a campaign's client is not always in the loaded client list.
export function usablePlatforms(client, allPlatforms) {
  return (client?.platform_ids || [])
    .map(pid => (allPlatforms || []).find(p => String(p.id) === String(pid)))
    .filter(p => p && p.is_active);
}
